import { lazy } from 'react'

export const OrderHistoryLazy = lazy(() => import('./OrderHistory'))
